import { createFileRoute } from '@tanstack/react-router'
import RegistroChaveDetailPage from '@/pages/chaves/registro-chave-detail'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota para /dashboard/$dashboardId/chaves/$registroChaveId
// Requer keysOwn OU keysAll para visualizar
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/chaves/$registroChaveId/',
)({
  component: function RegistroChaveDetailRoute() {
    const { dashboardId, registroChaveId } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.KEYS_OWN, CAPABILITIES.KEYS_ALL]}
        dashboardId={dashboardId}
      >
        <RegistroChaveDetailPage
          registroChaveId={registroChaveId}
          dashboardId={dashboardId}
        />
      </ProtectedRoute>
    )
  },
})
